(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function frameWidth(track) {
    return track ? track.clientWidth : 0;
  }

  function init(mediaRoot) {
    if (!mediaRoot || mediaRoot.dataset.carouselized === 'true') return;

    var total = Number(mediaRoot.dataset.imageCount || 0);
    var track = mediaRoot.querySelector('[data-card-track]');
    if (!track || total < 2) return;
    var enableSecondImageHover = mediaRoot.dataset.enableSecondImageHover === 'true';

    var prev = mediaRoot.querySelector('[data-card-prev]');
    var next = mediaRoot.querySelector('[data-card-next]');
    var range = mediaRoot.querySelector('[data-card-range]');
    var startX = null;
    var index = 0;

    function canHoverWithPointer() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function usesCoarsePointer() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }

    function syncControls() {
      if (range) {
        range.value = String(index);
        range.setAttribute('aria-valuenow', String(index));
      }

      if (prev) {
        prev.disabled = index <= 0;
      }

      if (next) {
        next.disabled = index >= total - 1;
      }

      if (enableSecondImageHover) {
        mediaRoot.classList.toggle('is-second-image-active', index > 0);
      }
    }

    function scrollToIndex(nextIndex, behavior) {
      index = clamp(nextIndex, 0, total - 1);
      track.scrollTo({
        left: frameWidth(track) * index,
        behavior: behavior || 'smooth'
      });
      syncControls();
    }

    function updateFromScroll() {
      var width = frameWidth(track);
      if (!width) return;

      index = clamp(Math.round(track.scrollLeft / width), 0, total - 1);
      syncControls();
    }

    function move(step) {
      scrollToIndex(index + step, 'smooth');
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(1);
      });
    }

    if (range) {
      range.addEventListener('input', function () {
        scrollToIndex(Number(range.value), 'auto');
      });
    }

    track.addEventListener('scroll', updateFromScroll, { passive: true });

    window.addEventListener('resize', function () {
      scrollToIndex(index, 'auto');
    });

    mediaRoot.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      startX = event.changedTouches[0].clientX;
    }, { passive: true });

    mediaRoot.addEventListener('touchend', function (event) {
      if (startX === null || !event.changedTouches || !event.changedTouches.length) return;

      var endX = event.changedTouches[0].clientX;
      var deltaX = endX - startX;
      startX = null;

      if (Math.abs(deltaX) < 30) return;
      move(deltaX > 0 ? -1 : 1);
    }, { passive: true });

    if (enableSecondImageHover) {
      mediaRoot.addEventListener('pointerenter', function () {
        if (!canHoverWithPointer()) return;
        scrollToIndex(1, 'smooth');
      });

      mediaRoot.addEventListener('pointerleave', function () {
        if (!canHoverWithPointer()) return;
        scrollToIndex(0, 'smooth');
      });

      mediaRoot.addEventListener('click', function (event) {
        if (!usesCoarsePointer()) return;

        var link = event.target.closest('a[href]');
        if (!link || !mediaRoot.contains(link)) return;

        if (index === 0) {
          event.preventDefault();
          scrollToIndex(1, 'smooth');
        }
      });
    }

    mediaRoot.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });

    mediaRoot.dataset.carouselized = 'true';
    syncControls();
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('.js-product-card-media[data-image-urls]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    boot(event.target);
  });
})();
